

















































import { Component, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

// Helpers
import { Meta } from '@/helpers/decorators'

// Api
import { mapData, MISSION_API_MAPPING } from '@/api/Mapping'

// Mixins
import Errors from '@/mixins/Errors'

// Components
import InfoBox from '@/components/common/InfoBox.vue'
import Box from '@/components/common/Box.vue'
import ImageViewer from '@/components/common/ImageViewer.vue'

// Views
import AssignReportForm from '@/views/all/forms/AssignReportForm.vue'
import TemplateCategoriesBox from '@/views/all/boxes/TemplateCategoriesBox.vue'
import TemplateReport from '@/views/report/partials/Report.vue'

@Component({
  components: {
    InfoBox,
    Box,
    ImageViewer,
    AssignReportForm,
    TemplateCategoriesBox,
    TemplateReport
  }
})
export default class CreateMission extends Mixins(Errors) {
  templateModalOpened: boolean = false
  prefillModalOpened: boolean = false
  reportLoading: boolean = false
  selected = null
  proovCode = null
  resend = false

  report = null
  changes = []

  missionCreating: boolean = false

  @Getter('token') token
  @Action('loadTemplate', { namespace: 'report' }) loadTemplateFromStore

  @Meta
  metas() {
    return {
      title: this.$t('menu.missions'),
      titleTemplate: `${this.$t('missions.tab.new')} - %s - ${process.env.VUE_APP_NAME}`
    }
  }

  get selectedHasDropoff() {
    return this.selected && this.selected.template.dropoff
  }

  get canShowPrefillModal() {
    return this.report && this.prefillModalOpened
  }

  async prefillReport() {
    try {
      this.reportLoading = true
      if (!this.proovCode || !this.report) {
        this.report = await this.loadTemplateFromStore(this.selected.template.id)
      }
      this.prefillModalOpened = true
    } finally {
      this.reportLoading = false
    }
  }

  closePrefillModal() {
    this.prefillModalOpened = false
  }

  closeTemplateModal() {
    this.templateModalOpened = false
  }

  chooseTemplate() {
    this.templateModalOpened = true
  }

  updateTemplate(datas) {
    this.closeTemplateModal()
    this.report = null
    this.selected = datas
  }

  async saveParts(changes) {
    this.changes = changes
    await this.updateParts()
    this.closePrefillModal()
  }

  async updateParts() {
    const res = await this.$api.reports.saveReportFromTemplate(this.token, this.selected.template.id)
    this.proovCode = res.data.proov_code
    await this.$api.reports.updateReportParts(this.token, this.proovCode, this.changes)
  }

  async createMission(formData) {
    this.missionCreating = true
    try {
      if (!this.proovCode) {
        const res = await this.$api.reports.saveReportFromTemplate(this.token, this.selected.template.id)
        this.proovCode = res.data.proov_code
      }
      let data = {
        ...formData,
        reportState: 'pending_first',
        proovCode: this.proovCode,
        bodySms: this.$t('missions.sms.content')
      }
      await this.$api.missions.createMission(this.token, mapData(MISSION_API_MAPPING, data, true, false))
      if (formData.resend) {
        data = {...data, reportState: 'pending_second'}
        const rep = await this.$api.missions.createMission(this.token, mapData(MISSION_API_MAPPING, data, true, false))
        console.log('on renvoit', rep)
      }
      this.$toast.open({
        message: this.$t('global.info_box.create_success_content') as string,
        type: 'is-success',
        duration: 5000
      })
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.missionCreating = false
      this.$router.push({ name: 'indexMissions' })
    }
  }
}
